import React, { ChangeEvent, FunctionComponent, useCallback } from 'react'
import cn from 'classnames'
import styles from './Switch.module.scss'

interface SwitchProps {
  className?: string
  checked: boolean
  onChange: (checked: boolean, name?: string) => void
  direction?: 'left' | 'right'
  name?: string
  label?: string
}
export const Switch: FunctionComponent<SwitchProps> = ({
  className,
  checked,
  onChange,
  name,
  label,
  direction = 'left',
}) => {
  const change = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked, name)
    },
    [name, onChange]
  )

  return (
    <label
      className={cn(styles.container, className, {
        [styles.right]: direction === 'right',
      })}
    >
      {label ? <span className={styles.label}>{label}</span> : null}
      <input
        type="checkbox"
        name={name}
        checked={checked}
        className={styles.input}
        onChange={change}
        data-testid="switchInput"
      />
      <span className={styles.icon}></span>
    </label>
  )
}
